import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full md:w-auto md:flex-none md:max-w-[40%]" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col rounded-lg overflow-hidden bg-[#F0F0F4]"
}
const _hoisted_3 = {
  key: 1,
  class: "w-4 h-4 mt-1"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_5 = { class: "flex flex-row items-center px-4 whitespace-nowrap" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", { class: "text-xl md:text-2xl" }, "Valor:", -1)
const _hoisted_7 = {
  key: 0,
  class: "flex items-start gap-2 px-3 py-2 rounded-md text-sm text-left",
  style: {"background":"#fef9e7","border":"1px solid rgba(241, 194, 27, 0.55)","border-left":"3px solid #f1c21b"}
}
const _hoisted_8 = {
  class: "flex-shrink-0 mt-0.5",
  style: {"color":"#b4860e"},
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "9",
  x2: "12",
  y2: "13"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "17",
  x2: "12.01",
  y2: "17"
}, null, -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "flex flex-col gap-1 min-w-0 text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 leading-snug text-textPrimary" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Valor não calculado."),
  /*#__PURE__*/_createTextVNode(" Este plantão pode não estar coberto por uma política de pagamento ativa na escala. ")
], -1)
const _hoisted_15 = ["aria-expanded", "onClick"]
const _hoisted_16 = {
  style: {"display":"inline","vertical-align":"middle"},
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","top":"-6px","left":"28px","width":"12px","height":"12px","background":"#fff","border-left":"1px solid #e0e0e8","border-top":"1px solid #e0e0e8","transform":"rotate(45deg)"} }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", { class: "m-0 mb-1.5 font-bold text-sm text-textPrimary" }, " Por que o valor não é calculado? ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-2 leading-snug text-gray-600" }, [
  /*#__PURE__*/_createTextVNode(" O valor fica como "),
  /*#__PURE__*/_createElementVNode("strong", null, "Não calculado"),
  /*#__PURE__*/_createTextVNode(" quando nenhuma política de pagamento ativa se aplica a este plantão específico. ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-1.5 leading-snug text-gray-600" }, "Causas mais comuns:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("ul", {
  class: "m-0 mb-2 pl-4 leading-snug text-gray-600",
  style: {"list-style":"disc"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, "Nenhuma política criada na escala deste plantão"),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Regras existentes não cobrem "),
    /*#__PURE__*/_createElementVNode("strong", null, "turno"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("strong", null, "equipe"),
    /*#__PURE__*/_createTextVNode(" ou "),
    /*#__PURE__*/_createElementVNode("strong", null, "posição"),
    /*#__PURE__*/_createTextVNode(" deste plantão ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Vigência da política expirada na data do plantão")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "rounded text-xs leading-relaxed",
  style: {"padding":"8px 10px","background":"#f4f4f8","color":"#52526f"}
}, [
  /*#__PURE__*/_createTextVNode(" Sugestão: valide com o gestor da escala se "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-textPrimary" }, "deveria haver valor"),
  /*#__PURE__*/_createTextVNode(" para este plantão e revise as políticas de pagamento aplicáveis. ")
], -1)
const _hoisted_27 = {
  key: 1,
  class: "flex flex-col gap-2 items-start px-4 py-3"
}
const _hoisted_28 = {
  key: 0,
  class: "bg-gray-200 rounded py-1 px-3 text-sm"
}
const _hoisted_29 = {
  key: 1,
  class: "bg-gray-200 rounded py-1 px-3 text-sm"
}

import { computed, ref, onMounted, onUnmounted } from 'vue'
import SVGIcon from '@/components/SVGIcon.vue'
import { mdiMinusCircleOutline, mdiLockOpenVariant, mdiLock } from '@mdi/js'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

type ApprovalStatus = 'Approved' | 'Rejected' | null


export default /*#__PURE__*/_defineComponent({
  __name: 'ValueDetailsSection',
  props: {
    originalValue: {},
    approvedValue: {},
    requestAntecipe: { type: Boolean },
    antecipeWasPaid: { type: Boolean },
    isExceptionMode: { type: Boolean },
    approvalStatus: {},
    scheduleId: {},
    showExceptionLock: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const permissionsStore = usePermissionsStore()

const canReadPaymentRules = computed(() => {
  if (!props.scheduleId) return false
  return permissionsStore.check({
    permission: AuthorizationPermissions.StationPaymentRulesReading,
    resource: {
      objectType: AuthorizationResourcesAndSubjects.Schedule,
      objectId: props.scheduleId
    }
  })
})

const canReadAntecipe = computed(() => {
  if (!props.scheduleId) return false
  return permissionsStore.check({
    permission: AuthorizationPermissions.StationAntecipeReading,
    resource: {
      objectType: AuthorizationResourcesAndSubjects.Schedule,
      objectId: props.scheduleId
    }
  })
})

const formatCurrency = (value: number | null | undefined): string | null => {
  if (value === null || value === undefined) return null
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

const formattedOriginalValue = computed(
  () => formatCurrency(props.originalValue) || 'Não calculado'
)
const formattedApprovedValue = computed(
  () => formatCurrency(props.approvedValue) || 'Não calculado'
)

const isValueNA = computed(() => props.originalValue == null && !props.isExceptionMode)

const isPolicyPopoverOpen = ref(false)
const saibaBtn = ref<HTMLElement | null>(null)
const popoverEl = ref<HTMLElement | null>(null)
const popoverPos = ref({ top: 0, left: 0 })

const popoverStyle = computed(() => ({
  position: 'fixed' as const,
  top: `${popoverPos.value.top}px`,
  left: `${popoverPos.value.left}px`,
  width: '320px',
  zIndex: 9999,
  border: '1px solid #E0E0E8',
  boxShadow: '0 12px 32px rgba(12,12,13,0.18), 0 2px 6px rgba(12,12,13,0.08)',
  padding: '14px'
}))

function togglePolicyPopover() {
  if (!isPolicyPopoverOpen.value && saibaBtn.value) {
    const rect = saibaBtn.value.getBoundingClientRect()
    const popoverWidth = 320
    const left = Math.min(rect.left, window.innerWidth - popoverWidth - 16)
    popoverPos.value = { top: rect.bottom + 8, left: Math.max(8, left) }
  }
  isPolicyPopoverOpen.value = !isPolicyPopoverOpen.value
}

function handleGlobalClick(e: MouseEvent) {
  if (!isPolicyPopoverOpen.value) return
  const target = e.target as Node
  if (popoverEl.value?.contains(target) || saibaBtn.value?.contains(target)) return
  isPolicyPopoverOpen.value = false
}

function handleEsc(e: KeyboardEvent) {
  if (e.key === 'Escape') isPolicyPopoverOpen.value = false
}

onMounted(() => {
  document.addEventListener('click', handleGlobalClick)
  document.addEventListener('keydown', handleEsc)
})
onUnmounted(() => {
  document.removeEventListener('click', handleGlobalClick)
  document.removeEventListener('keydown', handleEsc)
})

const originalValueContainerClasses = computed(() => {
  if (!props.isExceptionMode) return ''
  if (props.approvalStatus === 'Approved')
    return 'bg-[#F0F0F4] rounded-lg border-2 border-[#F0F0F4]'
  if (props.approvalStatus === 'Rejected')
    return 'rounded-lg border-2 border-primary30 overflow-hidden bg-[#E2E2E9]'
  return 'bg-[#F0F0F4]'
})

const originalValueTextClasses = computed(() => {
  if (props.isExceptionMode && props.approvalStatus === 'Approved') return 'text-gray-400'
  return 'text-[#212529]'
})

const originalValueIconClasses = computed(() => {
  if (props.isExceptionMode && props.approvalStatus === 'Rejected') return 'text-primary30'
  return 'text-negative'
})

const approvedValueContainerClasses = computed(() => {
  if (!props.isExceptionMode) return ''
  if (props.approvalStatus === 'Approved') return 'bg-[#FCE5E8]'
  if (props.approvalStatus === 'Rejected') return 'bg-[#F0F0F4]'
  return 'bg-[#FCE5E8]'
})

const approvedValueTextClasses = computed(() => {
  if (props.isExceptionMode && props.approvalStatus === 'Rejected') return 'text-gray-400'
  return 'text-[#212529]'
})

const approvedValueIconClasses = computed(() => {
  if (props.isExceptionMode && props.approvalStatus === 'Rejected') return 'text-gray-400'
  return 'text-negative'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isExceptionMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-row items-center gap-2 px-4 py-3", originalValueContainerClasses.value])
          }, [
            _createVNode(SVGIcon, {
              path: 
              _ctx.approvalStatus === 'Approved' || _ctx.approvalStatus === null
                ? _unref(mdiMinusCircleOutline)
                : _unref(mdiLock)
            ,
              class: _normalizeClass(["w-4 h-4", originalValueIconClasses.value])
            }, null, 8, ["path", "class"]),
            _createElementVNode("span", {
              class: _normalizeClass(["font-bold text-xl md:text-2xl", originalValueTextClasses.value])
            }, "Valor:", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["text-xl md:text-2xl ml-2", originalValueTextClasses.value])
            }, _toDisplayString(formattedOriginalValue.value), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-row items-center gap-2 px-4 py-3", approvedValueContainerClasses.value])
          }, [
            (_ctx.approvalStatus !== 'Rejected')
              ? (_openBlock(), _createBlock(SVGIcon, {
                  key: 0,
                  path: _unref(mdiLockOpenVariant),
                  class: _normalizeClass(["w-4 h-4", approvedValueIconClasses.value])
                }, null, 8, ["path", "class"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3)),
            _createElementVNode("span", {
              class: _normalizeClass(["font-bold text-xl md:text-2xl", approvedValueTextClasses.value])
            }, "Valor:", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["text-xl md:text-2xl ml-2", approvedValueTextClasses.value])
            }, _toDisplayString(formattedApprovedValue.value), 3)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (canReadPaymentRules.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.showExceptionLock)
                    ? (_openBlock(), _createBlock(SVGIcon, {
                        key: 0,
                        path: _unref(mdiLockOpenVariant),
                        class: "w-4 h-4 text-negative mr-2"
                      }, null, 8, ["path"]))
                    : _createCommentVNode("", true),
                  _hoisted_6,
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-xl md:text-2xl ml-2", { 'text-gray-400': isValueNA.value }])
                  }, _toDisplayString(formattedOriginalValue.value), 3)
                ]),
                (isValueNA.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_12)),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("button", {
                          ref_key: "saibaBtn",
                          ref: saibaBtn,
                          class: "self-start text-xs font-semibold underline underline-offset-2 bg-transparent border-0 p-0 cursor-pointer",
                          style: {"color":"#0043ce"},
                          "aria-expanded": isPolicyPopoverOpen.value,
                          "aria-controls": "policy-popover",
                          onClick: _withModifiers(togglePolicyPopover, ["stop"])
                        }, [
                          _createTextVNode(" Saiba mais "),
                          (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                        ], 8, _hoisted_15)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
                  (isPolicyPopoverOpen.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: "policy-popover",
                        ref_key: "popoverEl",
                        ref: popoverEl,
                        role: "dialog",
                        "aria-label": "Sobre o valor não calculado",
                        class: "rounded-lg bg-white text-sm text-left",
                        style: _normalizeStyle(popoverStyle.value)
                      }, [
                        _hoisted_19,
                        _createElementVNode("button", {
                          class: "absolute top-2 right-2 bg-transparent border-0 cursor-pointer rounded p-1 text-gray-400 hover:text-textPrimary hover:bg-gray-100",
                          "aria-label": "Fechar",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isPolicyPopoverOpen.value = false), ["stop"]))
                        }, _hoisted_21),
                        _hoisted_22,
                        _hoisted_23,
                        _hoisted_24,
                        _hoisted_25,
                        _hoisted_26
                      ], 4))
                    : _createCommentVNode("", true)
                ]))
              ]))
            : _createCommentVNode("", true),
          (canReadAntecipe.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_ctx.requestAntecipe)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Adiantamento solicitado"))
                  : _createCommentVNode("", true),
                (_ctx.antecipeWasPaid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Adiantamento pago"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})